import { Component, CUSTOM_ELEMENTS_SCHEMA, input, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { Button } from '@shui/angular';
import { OutOfOfficeOverviewEntry } from '../../models/out-of-office-overview.model';

@Component({
    selector: 'app-out-of-office-entry-detail',
    standalone: true,
    templateUrl: './out-of-office-entry-detail.component.html',
    imports: [TranslatePipe, Button],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class OutOfOfficeEntryDetailComponent {
    public readonly entry = input.required<OutOfOfficeOverviewEntry>();
    public readonly isAdmin = input<boolean>(false);
    public readonly isDeleting = input<boolean>(false);

    public readonly deleteClicked = output<void>();
    public readonly cancelClicked = output<void>();

    protected onDelete(): void {
        this.deleteClicked.emit();
    }

    protected onCancel(): void {
        this.cancelClicked.emit();
    }
}
